import { motion } from 'framer-motion';
import BLOCKS from '../data/blocks';

export default function ElementCard({ element, onClick, size = 'default' }) {
  const block = BLOCKS[element.block];
  const isSpeculative = element.block === 'future';
  
  const sizeClasses = {
    small: 'w-14 h-16 md:w-16 md:h-18',
    default: 'w-16 h-20 md:w-20 md:h-24',
    large: 'w-20 h-24 md:w-24 md:h-28',
  };

  return (
    <motion.button
      onClick={() => onClick(element)}
      className={`element-card ${sizeClasses[size]} rounded-lg p-1 flex flex-col items-center justify-center cursor-pointer`}
      style={{
        backgroundColor: `${block.color}15`,
        borderWidth: 2,
        borderStyle: isSpeculative ? 'dashed' : 'solid',
        borderColor: `${block.color}60`,
      }}
      whileHover={{ 
        scale: 1.1,
        borderColor: block.color,
        boxShadow: `0 0 20px ${block.color}40`,
      }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.2 }}
    >
      {/* Symbol */}
      <span 
        className="text-base md:text-lg font-bold leading-none"
        style={{ color: block.color }}
      >
        {element.symbol}
      </span>
      
      {/* Name */}
      <span className="text-[8px] md:text-[10px] text-gray-400 mt-1 text-center leading-tight line-clamp-2">
        {element.name}
      </span>
      
      {/* Speculative indicator */}
      {isSpeculative && (
        <span className="absolute top-0.5 right-0.5 text-[8px]" style={{ color: block.color }}>
          ✧
        </span>
      )}
    </motion.button>
  );
}
